import { Slide, LinearProgress } from '@mui/material';
import axios from 'axios';
import moment from 'moment';
import React, { useEffect } from 'react';
import { alertRef } from '../../../App';
import CheckBox from '../../../Components/CheckBox/CheckBox';
import Dropdown from '../../../Components/Dropdown/Dropdown';
import Modal from '../../../Components/Modal/Modal';
import { Button, Input } from '../../../Components/StyledComponents';
import './OptionSoldout.scss';

const OptionSoldout = () => {
    const [isDrag, setIsDrag] = React.useState(false)
    const [list, setList] = React.useState([])
    const [soldoutTime, setSoldoutTime] = React.useState(1)
    const [options, setOptions] = React.useState([])
    const [hour, setHour] = React.useState({});
    const [selected, setSelected] = React.useState();
    const [isLoading, setIsLoading] = React.useState(true)
    const modalRef = React.useRef(null);

    useEffect(() => {
        getOptionGroup();
        getOperationInfo();
    }, [])

    useEffect(()=>{
        getTimeOptions();
    }, [hour]);

    const setOptionSoldOut = (gid, id) => {
        axios.patch('/api/pickup/order/menu/option/sold_out/' + gid + '/' + id)
            .then((data) => {
                if (data.status === 204) {
                    getOptionGroup()
                    alertRef.current.showAlert({ title: '품절 설정이 완료 되었어요.', isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
                }
            })
            .catch(() => {
                alertRef.current.showAlert({ title: `다시 시도해 주세요.`, isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
            })
    }

    const deleteOptionSoldOut = (gid, id) => {
        axios.delete('/api/pickup/order/menu/option/sold_out/' + gid + '/' + id)
            .then((data) => {
                if (data.status === 204) {
                    getOptionGroup()
                    alertRef.current.showAlert({ title: '품절 설정이 해제 되었어요.', isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
                }
            })
            .catch(() => {
                alertRef.current.showAlert({ title: `다시 시도해 주세요.`, isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
            })
    }

    const changeRestockDate = () => {
        axios.patch('/api/pickup/order/menu/option/restock/' + selected.gid + '/' + selected.id, {
            DaysLeft: soldoutTime
        })
            .then((data) => {
                if (data.status === 204) {
                    getOptionGroup()
                    modalRef.current.closeModal()
                    alertRef.current.showAlert({ title: '품절 해제일이 변경되었어요.', isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
                }
            })
            .catch(() => {
                alertRef.current.showAlert({ title: `다시 시도해 주세요.`, isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
            })
    }

    const getOperationInfo = () => {
        axios.get('/api/pickup/order/info/operation_hours')
            .then((data) => {
                setHour(data.data.TableOrderInfo.OperationHours)
            })
    }

    const getTimeOptions = () => {
        let today = new Date();
        let time = '09:00';
        let satTime = '09:00';
        let sunTime = '09:00';


        if (typeof hour !== 'undefined' && Object.keys(hour).length > 0) {
            if (!hour.Weekday.Allday) {
                time = String(hour.Weekday.OpenHour).padStart(2, '0') + ':' + String(hour.Weekday.OpenMin).padStart(2, '0') 
            }
            sunTime = time
            satTime = time

            if (!hour.Everyday) {
                if (!hour.Saturday.Allday) satTime = String(hour.Saturday.OpenHour).padStart(2, '0') + ':' + String(hour.Saturday.OpenMin).padStart(2, '0')
                else satTime = '09:00';
                if (!hour.Sunday.Allday) sunTime = String(hour.Sunday.OpenHour).padStart(2, '0') + ':' + String(hour.Sunday.OpenMin).padStart(2, '0')
                else sunTime = '09:00';
            }
        }
        let arr = [];
        for (let i = 1; i < 8; i++) {
            let newDay = moment(today).add(i, 'days');
            let newTime = time;
            if (newDay.day() === 6) newTime = satTime
            else if (newDay.day() === 0) newTime = sunTime

            arr.push({
                key: moment(today).add(i, 'days').format('YYYY-MM-DD(dd)') + ` ${newTime}에 해제`,
                value: i
            })
        }
        setOptions(arr)
    }

    const getOptionGroup = () => {
        setIsLoading(true)
        axios.get('/api/pickup/order/menu/option/group')
            .then((data) => {
                setList(data.data)
                setIsLoading(false)
            })
            .catch(() => {
                setIsLoading(false)
            })
    }

    return (
        <div className='menu-soldout-info'>
            <div className='header-row between'>
                <div />
            </div>
            {
                isLoading ?
                    <LinearProgress color="error" />
                    :
                    null
            }

            {
                isLoading ?
                    null
                    :
                    list.length > 0 ?
                        list.map((data, i) => (
                            <div className='menu-group-box' key={i}>
                                <div>
                                    <p className='menu-group-name'>{data.Name.ko}</p>
                                    <div className='row' style={{ marginBottom: 8 }}>
                                        <div className='option-box'>옵션 개수</div>
                                        <p className='option-sub'>{
                                            data.isRequire && '최소 ' + data.SelectableCount.Min + '개'
                                        } 최대{data.SelectableCount.Max}개 선택가능</p>
                                    </div>
                                    <div className='row' style={{ marginBottom: 32 }}>
                                        <div className='option-box'>연결 메뉴</div>
                                        <p className='option-sub'>
                                            {
                                                data.ConnectedMenuInfo.length === 0
                                                    ?
                                                    '연결된 메뉴가 없습니다.'
                                                    :
                                                    data.ConnectedMenuInfo.map((item, i) => {
                                                        return item.Name.ko + ((i === data.ConnectedMenuInfo.length - 1) ? '' : ', ')
                                                    })
                                            }
                                        </p>
                                    </div>
                                </div>

                                {
                                    data.OptionInfo.map((item, i) => {
                                        return (
                                            <div key={i}>
                                                <div className='row between'>
                                                    <div className='row'>
                                                        <Slide direction='right' in={isDrag} mountOnEnter unmountOnExit style={{ transitionDuration: '0.4s' }}>
                                                            <p className='move-icon' style={{ width: isDrag ? 64 : 0, transition: 'all', transitionDuration: '0.3s' }}>
                                                                <CheckBox containerStyle={{ width: 64, margin: 0, height: 24 }} />
                                                            </p>
                                                        </Slide>
                                                        <div>
                                                            <p className='menu-name'>{item.Name.ko}</p>
                                                            {
                                                                item.isSoldOut &&
                                                                <div className='row' style={{ marginTop: 12 }}>
                                                                    <div className='soldout-box'>
                                                                        품절
                                                                    </div>
                                                                    <p className='soldout-text'>{moment(item.RestockDate.$date).utc().local('ko').format('YYYY-MM-DD(dd) HH:mm')} 에 자동으로 해제되어 판매 가능해요</p>
                                                                    <p className='change-soldout' onClick={() => { setSelected({ gid: data._id.$oid, id: item._id.$oid }); modalRef.current.openModal() }}>품절 해제일 변경</p>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className='row' style={{ alignItems: 'center', justifyContent: 'center', opacity: isDrag ? 0 : 1, transition: 'all', transitionDuration: '0.5s' }}>
                                                        {
                                                            item.isSoldOut ?
                                                                <Button variant='outline' small style={{ width: 88, borderColor: '#3d9822', color: '#3d9822' }} onClick={() => alertRef.current.showAlert({ title: `해당 옵션을 품절 해제 할까요?`, isConfirm: true, confirmText: '해제하기', isCancel: true, cancelText: '취소', onConfirm: () => { alertRef.current.hideAlert(); deleteOptionSoldOut(data._id.$oid, item._id.$oid) } })}>
                                                                    품절해제
                                                                </Button>
                                                                :
                                                                <Button variant='outline' small style={{ width: 88 }} onClick={() => alertRef.current.showAlert({ title: `옵션을 품절 상태로 변경할까요?`, subTitle: '품절 상태로 변경되면 연동된 모든 메뉴에서 옵션 선택이 불가능해요.', isConfirm: true, confirmText: '변경하기', isCancel: true, cancelText: '취소', onConfirm: () => { alertRef.current.hideAlert(); setOptionSoldOut(data._id.$oid, item._id.$oid) } })}>
                                                                    품절
                                                                </Button>
                                                        }
                                                    </div>
                                                </div>
                                                {
                                                    i !== data.OptionInfo - 1 &&
                                                    <div className='divider' />
                                                }
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        ))
                        :
                        <div>
                            <p className='empty-list'>생성된 옵션이 없습니다.</p>
                        </div>
            }

            <Modal ref={modalRef} contentContainer={{ width: 500 }} isHeader title='품절 해제일 변경'>
                <>
                    <div>
                        <p className='label' style={{ width: 'fit-content' }}>품절 해제 시간</p>
                        <Dropdown
                            width={420}
                            options={options}
                            btnStyle={{ marginTop: 24, marginBottom: 12 }}
                            value={options.length > 0 ? options[soldoutTime - 1].key : ''}
                            onItemClick={(val) => setSoldoutTime(val)}
                        />
                    </div>
                    <p className='warn-soldout'>* 품절은 가게 운영 시작시간에 맞춰 해제됩니다.</p>

                    <div className='btn-row'>
                        <Button variant="main" className='save-btn' fontSize={16} onClick={() => alertRef.current.showAlert({ title: `옵션을 품절 일자를 변경할까요?`, subTitle: '설정하신 날짜에 자동으로 품절이 해제되어 판매 가능해요.', isConfirm: true, confirmText: '변경하기', isCancel: true, cancelText: '취소', onConfirm: () => { alertRef.current.hideAlert(); changeRestockDate() } })}>
                            변경하기
                        </Button>
                    </div>
                </>
            </Modal>
        </div>
    )
}

export default OptionSoldout;